import { SET_COMPANIES_DATA, SET_FILTER } from './mutation-types'
import dataService from '@/services/data.service'
import options from '@/data/options'
import geo from '@/helpers/geo'
import format from '@/helpers/format'

const state = {
  companies: dataService.getCompanies(),
  filters: {
    baseCountry: '',
    sector: '',
    displayName: '',
    sdg: [],
    otherDevTags: [],
    _consolidatedFinRevenueRange: [0, 7],
    _consolidatedEmployeeRange: [0, 8],
  },
}

const mutations = {
  [SET_COMPANIES_DATA](state, payload) {
    state.companies = payload
  },
  [SET_FILTER](state, { key, value }) {
    state.filters[key] = value
  },
}

const actions = {
  getCompaniesData({ commit }) {
    const data = dataService.getCompanies()
    commit(SET_COMPANIES_DATA, data)
  },
  setFilter({ commit }, payload) {
    commit(SET_FILTER, payload)
  },
}

const getters = {
  allCompanies: state => state.companies,
  companies: state => {
    return state.companies.filter(company => {
      const filters = Object.entries(state.filters)
      const normalizedFilters = filters.map(filter => {
        if (filter[0] === '_consolidatedFinRevenueRange') {
          const revenueRanges = format.getRangesFromSliderValues(filter[1], options.revenueOptions)
          return ['_consolidatedFinRevenueRange', revenueRanges]
        }
        if (filter[0] === '_consolidatedEmployeeRange') {
          const employeeRanges = format.getRangesFromSliderValues(filter[1], options.employeeOptions)
          return ['_consolidatedEmployeeRange', employeeRanges]
        }
        return filter
      })

      const appliedFilters = normalizedFilters.filter(f => f[1].length)
      if (!appliedFilters.length) {
        return true
      }

      const isMatch = !appliedFilters.some(filter => {
        const companyFieldValue = company.data[filter[0]]
        const filterValue = filter[1]
        if (companyFieldValue === undefined) {
          return true
        }
        // checking for multiselect filters
        if (Array.isArray(filterValue)) {
          if (Array.isArray(companyFieldValue)) {
            return !filterValue.some(item => companyFieldValue.includes(item))
          } else {
            return !filterValue.includes(companyFieldValue)
          }
        }
        if (filter[0] === 'displayName') {
          const splittedQueries = filterValue.toLowerCase().split(' ')
          return !splittedQueries.every(query => {
            return companyFieldValue.toLowerCase().includes(query)
          })
        }
        return filterValue !== companyFieldValue
      })
      return isMatch
    })
  },
  inBoundsCompanies: (state, getters, rootState, rootGetters) => {
    const bounds = rootGetters['map/bounds']
    return getters.companies.filter(company => {
      const { lng, lat } = company.coordinates
      const point = { lat, lng }
      return geo.isInBounds(point, bounds)
    })
  },
  countryOptions: state => {
    const countries = state.companies.map(company => company.data.baseCountry)
    const options = [...new Set(countries)].map(item => ({
      text: item,
      value: item,
    }))
    return [{ text: 'Any country', value: '' }, ...options]
  },
  sectorOptions: state => {
    const sectors = state.companies.map(company => company.data.sector)
    const options = [...new Set(sectors)].map(item => ({
      text: item,
      value: item,
    }))
    return [{ text: 'Any sector', value: '' }, ...options]
  },
  selectedCountry: state => state.filters.baseCountry,
  selectedSector: state => state.filters.sector,
  selectedDisplayName: state => state.filters.displayName,
  selectedOtherDevTags: state => state.filters.otherDevTags,
  selectedSdg: state => state.filters.sdg,
  selectedRevenueRange: state => state.filters._consolidatedFinRevenueRange,
  selectedEmployeeRange: state => state.filters._consolidatedEmployeeRange,
  allCompaniesCount: state => state.companies.length,
  filteredCompaniesCount: (state, getters) => getters.companies.length,
  inBoundsCompaniesCount: (state, getters) => getters.inBoundsCompanies.length,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
